import React, { useState, useMemo, useEffect, Fragment } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import axios from "axios";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "./Weathers.css";
import { MdModeEditOutline } from "react-icons/md";
import { AiFillDelete } from "react-icons/ai";
import Footer from "../Footer/footer";
import Sidebar from "../Sidebar/sidebar";
import Header from "../Header/header";
import Modal_Popup from "../../components/modal_renderer/Modal_Popup";
import { Controller, useForm } from "react-hook-form";
import Modal from "react-bootstrap/Modal";
import UpdateWeathers from "./UpdateWeathers";
import Compressor from "compressorjs";
import { ToastContainer, toast } from "react-toastify";
import { Button } from "react-bootstrap";
import RenderImage from "../../components/Image";
import { exportToExcel } from "react-json-to-excel";
import Select from "react-select";
import { CSVLink } from "react-csv";

function Weathers() {
  const {
    register: uploadRegister,
    unregister,
    handleSubmit: handlesubmitUpload,
    reset,
    watch,
    control,
    setValue,
    formState: { errors: uploaderrors },
  } = useForm({ mode: "onBlur" });

  const {
    register: uploadregister,
    handleSubmit: uploadhandleSubmit,
    unregister: uploadunregister,
    formState: { errors },
    reset: uploadreset,
  } = useForm();

  const [UpdateWeatherData, setUpdateWeatherData] = useState();
  const [DeleteCategoriesId, setDeleteCategoriesId] = useState("");
  const [tags, setTags] = useState("");
  const [editIsOpen, setEditIsOpen] = useState(false);
  const rowHeight = 55;

  const ChildMessageRenderer = (props) => {
    return (
      <div className="iconActionList">
        <div
          className="editIcon"
          onClick={() => {
            setUpdateWeatherData(props.data);
            setEditIsOpen(true);
          }}
        >
          <MdModeEditOutline className="ActionIcon" />
        </div>
        <div
          className="DeleteIcon"
          onClick={() => {
            setDeleteCategoriesId(props.data._id);
          }}
          data-bs-toggle="modal"
          data-bs-target="#DeleteCategoriesData"
        >
          <AiFillDelete className="ActionIcon" />
        </div>
      </div>
    );
  };

  const resetForm = () => {
    setTags("");
    setSendinnericonImage("");
    setInnericon("");
  };

  function fun() {
    // setUploadIsOpen(false);
    // setLoader(false);
  }

  const SrNoRenderer = (props) => {
    return <span className="profle_img_box">{props.rowIndex + 1}</span>;
  };

  const WeatherNameRenderer = (props) => {
    return (
      <span className="profle_img_box">
        <span>{props.data.weatherTagName}</span>
      </span>
    );
  };

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      minWidth: 100,
      sortable: true,
      resizable: true,
      filter: true,
      getQuickFilterText: (params) => {
        return params.value.name;
      },
      editable: true,
    };
  }, []);

  const editdataReloadFunc = () => {
    getweather();
  };

  const customLowerCaseComparator = (valueA, valueB) => {
    if (typeof valueA === "string") {
      return valueA?.toLowerCase().localeCompare(valueB?.toLowerCase());
    }
    return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
  };
  const statusValueGetter = (params) => {
    return params.data.status;
  };
  //----------//---------//
  const [isOpen, setIsOpen] = useState(false);
  const [active, setActive] = useState(-1);

  function somefun() {
    setIsBulkUploadOpen(false);
    setIsOpen(false);
    cancelForm();
  }
  function cancelForm() {
    reset();
  }
  function fun() {
    setIsOpen(false);
  }
  //---------Get weather Api -----//
  useEffect(() => {
    getweather();
    getImageCategory();
  }, []);
  const [rowData, setRowData] = useState([]);

  function close() {
    setEditIsOpen(false);
    setUpdateWeatherData({});
    setRowData(rowData);
  }
  const [downloadData, setDownloadData] = useState([]);

  function getweather() {
    let config = {
      method: "get",
      url: `${process.env.REACT_APP_BASEURL}/getweathertag`,
      headers: {
        Authorization: localStorage.getItem("AdminToken"),
        "Content-Type": "application/json",
      },
    };

    axios(config)
      .then(function (response) {
        setRowData(response.data.result);
        const downloadData = response.data.result?.map(
          ({ weatherTagName, icon, _id, status }) => {
            return {
              weatherTagName: weatherTagName ? weatherTagName : "",
              icon: icon ? icon : "",
              status: status ? status : "",
            };
          }
        );
        setDownloadData(downloadData);
      })
      .catch(function (error) {
        // console.log(error);
      });
  }
  //---------Add weather Api -----//

  //--------Function to handle and set Author Image--------//
  const [innericon, setInnericon] = useState("");
  const [sendinnericonImage, setSendinnericonImage] = useState("");
  const handleAuthorImage = (event) => {
    if (event.target.files[0]) {
      let file = event.target.files[0];
      new Compressor(file, {
        quality: 0.2, // 0.6 can also be used, but its not recommended to go below.
        success: (compressedResult) => {
          // compressedResult has the compressed file.
          // Use the compressed file to upload the images to your server.
          let display = URL.createObjectURL(compressedResult);
          setInnericon(display);
          setSendinnericonImage(compressedResult);
          setErr(false);
        },
      });
    }
  };
  //-------//--------//

  //--------Function to render images--------//

  const [err, setErr] = useState(false);
  function addnewWeather(postdata) {
    if (!postdata) {
      setErr(true);
    } else {
      setIsOpen(false);
      setErr(false);
      let data = new FormData();
      console.log("postdata.wellgorithmIcon", postdata.wellgorithmIcon);
      data.append(
        "icon",
        postdata.wellgorithmIcon[0] === "h"
          ? postdata.wellgorithmIcon
          : postdata.wellgorithmIcon[0]
      );
      data.append("weatherTagName", postdata.weatherTagName);

      let config = {
        method: "post",
        url: `${process.env.REACT_APP_BASEURL}/createweathertag`,
        headers: {
          Authorization: localStorage.getItem("AdminToken"),
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios(config)
        .then(function (response) {
          resetForm();
          reset();
          getweather();
        })
        .catch(function (error) {
          // console.log(error);
        });
    }
  }
  //---------Status Inners Api -----//

  const StatusRenderer = (props) => {
    let status = props?.data?.status ? "deactivate" : "activate";
    let message = "Are you sure you want to " + status + " this Weather?";
    return (
      <Modal_Popup
        status={props?.data?.status}
        onClick={() => {
          changeTagStatus(props?.data?._id);
        }}
        message={message}
      />
    );
  };
  function changeTagStatus(weathertagId) {
    let data = JSON.stringify({
      weathertagId: weathertagId,
    });

    let config = {
      method: "PATCH",
      url: `${process.env.REACT_APP_BASEURL}/changeweathertagstatus`,
      headers: {
        Authorization: localStorage.getItem("AdminToken"),
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        getweather();
      })
      .catch(function (error) {
        // console.log(error);
      });
  }
  //---------delete Inners Api -----//
  function deleteWeather(index) {
    let data = JSON.stringify({
      weatherId: index,
    });

    let config = {
      method: "patch",
      url: `${process.env.REACT_APP_BASEURL}/deleteweather`,
      headers: {
        Authorization: localStorage.getItem("AdminToken"),
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        getweather();
      })
      .catch(function (error) {
        // console.log(error);
      });
  }

  const [isBulkUploadOpen, setIsBulkUploadOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  function bulkupload({ uploadImages }) {
    // setIsLoading(true);
    const formData = new FormData();

    formData.append("attachment", uploadImages[0]);
    // formData.append("images", uploadImages);
    let config = {
      method: "post",
      url: `${process.env.REACT_APP_BASEURL}/weatherbulkupload`,
      headers: {
        Authorization: localStorage.getItem("AdminToken"),
        // "Content-Type": "application/json",
      },
      data: formData,
    };

    axios(config)
      .then(function (response) {
        if (response.data.status) {
          toast.success(response.data.message);
          uploadreset();
          somefun();
          getweather();
        }
      })
      .catch(function (error) {
        toast.error(error.message ?? "Something went wrong");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const [directoryData, setDirectoryData] = useState([]);
  const [imagesData, setImagesData] = useState([]);

  function getImageCategory() {
    let config = {
      method: "get",
      url: `${process.env.REACT_APP_BASEURL}/getallimages`,
      headers: {
        Authorization: localStorage.getItem("AdminToken"),
        "Content-Type": "application/json",
      },
    };

    axios(config)
      .then(function (response) {
        const directories = response.data.result.map((item) => ({
          value: item?.imageCategoryId?._id,
          label: item?.imageCategoryId?.imageCategory,
          images: item.images,
        }));
        setDirectoryData(directories);
      })
      .catch(function (error) {
        toast.error(error.message ?? "Something went wrong");
      });
  }

  const headers = [
    { label: "Weather", key: "weatherTagName" },
    { label: "Icon", key: "icon" },
    { label: "Status", key: "status" },
  ];

  const escapeCsvValue = (value) => {
    if (typeof value === "string") {
      // Escape double quotes by doubling them
      value = value.replace(/"/g, '""');
      // Wrap value in double quotes if it contains a comma, double quote, or newline
      // if (value.includes(",") || value.includes('"')) {
      //   value = `"${value}"`;
      // }
    }
    console.log("value", value);
    return value;
  };

  // Function to prepare data by escaping CSV values
  const prepareData = (data) => {
    return data.map((row) =>
      Object.fromEntries(
        Object.entries(row).map(([key, value]) => [key, escapeCsvValue(value)])
      )
    );
  };

  const preparedData = prepareData(downloadData);

  return (
    <>
      <Header />
      <Sidebar />
      <ToastContainer />

      <div className="page-wrapper">
        <div className="container-fluid ">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">
                Weather Tag
                <div className="float-end btns_head d-flex">
                  <button
                    className="btn btn-theme btn-sm"
                    onClick={() => setIsBulkUploadOpen(true)}
                  >
                    Bulk Upload
                  </button>
                  <button
                    className="btn btn-theme btn-sm"
                    onClick={() => setIsOpen(true)}
                  >
                    Add Weather Tag
                  </button>
                  <CSVLink
                    data={preparedData}
                    headers={headers}
                    filename="WeathersTag.csv"
                    className="btn btn-theme btn-sm"
                  >
                    Export
                  </CSVLink>
                </div>
              </h4>

              {/* Upload Images */}

              <div>
                <Modal
                  show={isBulkUploadOpen}
                  onHide={() => setIsBulkUploadOpen(false)}
                >
                  <form onSubmit={uploadhandleSubmit(bulkupload)}>
                    <Modal.Header closeButton>
                      <Modal.Title> Upload Weathers</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="row">
                        <div className="col-md-12 mb-3">
                          <label className="form-label">File</label>
                          <div className="position-relative">
                            <input
                              type="file"
                              multiple
                              // value={tags}
                              className="form-control"
                              {...uploadregister("uploadImages", {
                                required: true,
                              })}
                              onChange={(e) => {
                                uploadunregister("uploadImages");
                              }}
                              name="uploadImages"
                            />
                            {errors?.uploadImages?.type === "required" && (
                              <p style={{ color: "red" }}>
                                This field is required
                              </p>
                            )}

                            <div
                              className="hint_box"
                              style={{ display: "block" }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => {
                          setIsBulkUploadOpen(false);
                          reset();
                        }}
                      >
                        Close
                      </Button>
                      <button type="submit" disabled={isLoading}>
                        {" "}
                        {isLoading ? "Loading..." : "Submit"}
                      </button>
                    </Modal.Footer>
                  </form>
                </Modal>
              </div>

              {/* //--Add waether---// */}
              <div>
                <Modal show={isOpen} onHide>
                  <Modal.Body>
                    <div
                      tabIndex="-1"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog modal-dialog-scrollable">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                              Add Weather
                            </h5>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => somefun()}
                            ></button>
                          </div>
                          <form onSubmit={handlesubmitUpload(addnewWeather)}>
                            <div className="modal-body">
                              <div className="row">
                                <div className="col-md-12 mb-3">
                                  <label className="form-label">
                                    Weather Tag
                                  </label>
                                  <div className="position-relative">
                                    <input
                                      className="form-control"
                                      {...uploadRegister("weatherTagName", {
                                        required: true,
                                      })}
                                    />

                                    {uploaderrors?.weatherTagName?.type ===
                                      "required" && (
                                      <p style={{ color: "red" }}>
                                        This field is required
                                      </p>
                                    )}
                                    <div
                                      className="hint_box"
                                      style={{ display: "block" }}
                                    ></div>
                                  </div>
                                </div>

                                <div className="col-md-12 mb-3">
                                  <label className="form-label">
                                    Weathers Image
                                  </label>

                                  <div className="position-relative">
                                    <label className="form-label">
                                      Upload File
                                      <input
                                        {...uploadRegister("uploadFile", {
                                          required: true,
                                        })}
                                        type="radio"
                                        value="file"
                                      />
                                    </label>
                                    <label className="form-label">
                                      from directory
                                      <input
                                        {...uploadRegister("uploadFile", {
                                          required: true,
                                        })}
                                        type="radio"
                                        value="from directory"
                                      />
                                    </label>
                                    <label className="form-label">
                                      Image URL
                                      <input
                                        {...uploadRegister("uploadFile", {
                                          required: true,
                                        })}
                                        type="radio"
                                        value="image url"
                                      />
                                    </label>
                                    {errors?.uploadFile?.type ===
                                      "required" && (
                                      <p style={{ color: "red" }}>
                                        This field is required
                                      </p>
                                    )}
                                    {watch("uploadFile") === "file" && (
                                      <ul className="imagesUpload">
                                        <li
                                          style={{
                                            width: "100%",
                                            height: "128px",
                                          }}
                                        >
                                          <input
                                            type="file"
                                            {...uploadRegister(
                                              "wellgorithmIcon",
                                              {
                                                required:
                                                  watch("uploadFile") === "file"
                                                    ? true
                                                    : false,
                                              }
                                            )}
                                            onChange={(e) => {
                                              handleAuthorImage(e);
                                              unregister("wellgorithmIcon");
                                            }}
                                          />

                                          {innericon.length === 0 ? (
                                            <img
                                              alt="renderImages"
                                              style={{
                                                width: "100%",
                                                height: "128px",
                                              }}
                                              src="../../images/defalutimg.svg"
                                            />
                                          ) : (
                                            <RenderImage image={innericon} />
                                          )}

                                          {errors?.wellgorithmIcon?.type ===
                                            "required" && (
                                            <p style={{ color: "red" }}>
                                              This field is required
                                            </p>
                                          )}

                                          {errors?.wellgorithmIcon?.type ===
                                            "validate" && (
                                            <p style={{ color: "red" }}>
                                              File size should be 500KB or less
                                            </p>
                                          )}
                                        </li>
                                      </ul>
                                    )}
                                    {watch("uploadFile") ===
                                      "from directory" && (
                                      <Fragment>
                                        <Controller
                                          name="directory"
                                          control={control}
                                          rules={{
                                            required: "This field is required",
                                          }}
                                          render={({ field }) => (
                                            <Select
                                              {...field}
                                              isSearchable={false}
                                              className="react-dropdown"
                                              classNamePrefix="dropdown"
                                              options={directoryData}
                                              onChange={(event) => {
                                                field.onChange(event); // Update the field value
                                                setImagesData(event.images);
                                              }}
                                            />
                                          )}
                                        />
                                        {Object.keys(errors).includes(
                                          "directory"
                                        ) && (
                                          <p style={{ color: "red" }}>
                                            {errors.directory.message}
                                          </p>
                                        )}{" "}
                                        <div class="imageList">
                                          {imagesData &&
                                            imagesData.length > 0 &&
                                            imagesData.map((item, index) => (
                                              <Controller
                                                name="wellgorithmIcon"
                                                control={control}
                                                render={() => (
                                                  <div
                                                    className={`uploadedImg ${
                                                      active === index &&
                                                      "active"
                                                    }`}
                                                    onClick={() => {
                                                      setValue(
                                                        "wellgorithmIcon",
                                                        item.location
                                                      );
                                                      setActive(index);
                                                    }}
                                                  >
                                                    <img
                                                      height={50}
                                                      width={50}
                                                      alt="icon"
                                                      src={item?.location}
                                                    />
                                                  </div>
                                                )}
                                              />
                                            ))}
                                        </div>
                                      </Fragment>
                                    )}
                                    {watch("uploadFile") === "image url" && (
                                      <div>
                                        <input
                                          type="text"
                                          {...uploadRegister(
                                            "wellgorithmIcon",
                                            {
                                              required:
                                                watch("uploadFile") ===
                                                "image url"
                                                  ? true
                                                  : false,
                                            }
                                          )}
                                          placeholder="Enter Image URL"
                                        />

                                        {/* {innericon.length === 0 ? (
                                            <img
                                              alt="renderImages"
                                              style={{
                                                width: "100%",
                                                height: "128px",
                                              }}
                                              src="../../images/defalutimg.svg"
                                            />
                                          ) : (
                                            <RenderImage image={innericon} />
                                          )} */}

                                        {errors?.wellgorithmIcon?.type ===
                                          "required" && (
                                          <p style={{ color: "red" }}>
                                            This field is required
                                          </p>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                onClick={() => somefun()}
                                type="button"
                                className="btn btn-danger CancelBtn"
                              >
                                Cancel
                              </button>
                              <button type="submit" className="btn submitBtn">
                                Submit
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
              </div>
              {/* //--//---// */}

              {/* delete */}
              <div
                className="modal fade"
                id="UpdateCategoriesData"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              ></div>
              <div
                className="modal fade DeletePopup"
                id="DeleteCategoriesData"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog  modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="">
                            <p>Are you sure you want to delete this Weather</p>
                            <button
                              type="button"
                              className="btn btn-danger CancelBtn"
                              data-bs-dismiss="modal"
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              onClick={() => {
                                deleteWeather(DeleteCategoriesId);
                              }}
                              className="btn submitBtn"
                              data-bs-dismiss="modal"
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* delete */}

              {/* edit */}
              {editIsOpen && (
                <div
                  className="modal fade"
                  id="UpdateWeatherData"
                  tabIndex="-1"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">
                      <UpdateWeathers
                        updatedData={UpdateWeatherData}
                        onEditDataFunction={editdataReloadFunc}
                        editIsOpen={editIsOpen}
                        close={close}
                      />
                    </div>
                  </div>
                </div>
              )}
              {/* edit */}

              <div
                style={{ width: "100%" }}
                className="ag-theme-alpine tableFix"
              >
                <AgGridReact
                  rowHeight={rowHeight}
                  rowData={rowData}
                  defaultColDef={defaultColDef}
                  frameworkComponents={{
                    childMessageRenderer: ChildMessageRenderer,
                    srNoRenderer: SrNoRenderer,
                    statusRenderer: StatusRenderer,
                    weatherNameRenderer: WeatherNameRenderer,
                  }}
                >
                  <AgGridColumn
                    width={90}
                    field="SrNo"
                    Srno={true}
                    sortable={false}
                    filter={false}
                    cellRenderer="srNoRenderer"
                  ></AgGridColumn>
                  <AgGridColumn
                    width={260}
                    cellRenderer="weatherNameRenderer"
                    field="weatherTagName"
                    sortable={true}
                    comparator={customLowerCaseComparator}
                  ></AgGridColumn>
                  <AgGridColumn
                    width={300}
                    field="Status"
                    cellRenderer="statusRenderer"
                    colId="params"
                    sortable={true}
                    filter={true}
                    valueGetter={statusValueGetter}
                  ></AgGridColumn>
                  <AgGridColumn
                    width={300}
                    field="Action"
                    cellRenderer="childMessageRenderer"
                    sortable={false}
                    filter={false}
                  ></AgGridColumn>
                </AgGridReact>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Weathers;
